/**
 * API Client
 *
 * Centralized Axios instance with auth interceptors for automatic
 * token management and 401 refresh handling.
 */

import axios from 'axios';
import { setupInterceptors } from './authInterceptor';

// API Gateway base URL from environment
const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

if (!API_BASE_URL) {
  console.error('REACT_APP_API_ENDPOINT is not set. Run `make config-env-mobile` to generate .env file.');
}

// Create Axios instance with default configuration
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup auth interceptors for automatic token handling
setupInterceptors(apiClient);

export default apiClient;
